import dayjs from 'dayjs';

import { type RawDate } from '@/types/globals';

const overwatchDate = (
  rawDate: string | RawDate | null | undefined,
  includeTime: boolean = false,
  dateFormat: string = 'Do MMM YYYY',
  timeFormat: string = 'h:mm A',
) => {
  if (!rawDate) {
    return {
      date: 'Invalid date received',
      tooltipDate: 'Invalid date received',
    };
  }
  return {
    date: dayjs(rawDate as unknown as string).format(includeTime ? `${dateFormat} [at] ${timeFormat}` : dateFormat),
    tooltipDate: dayjs(rawDate as unknown as string).format(
      includeTime ? `${dateFormat}, (dddd) [at] ${timeFormat}` : `${dateFormat} (dddd)`,
    ),
  };
};

/** @deprecated Use `objectLength` instead. */
export const formatDate = overwatchDate;

export default overwatchDate;
